import { createFileRoute } from "@tanstack/react-router";

import { FillScreen } from "@/components/Layout";
import { useGetGroupId } from "@/routes/_staff/ids/-api";

import { RuleAndPolicyDetail } from "../-components/RuleAndPolicyDetail";
import { RuleAndPolicyEmpty } from "../-components/RuleAndPolicyEmpty";

export const Route = createFileRoute(
  "/_staff/ids/group-id/$id/_$id/rule-and-policy/",
)({
  component: RuleAndPolicyPage,
});

function RuleAndPolicyPage() {
  const proxyUserId = Route.useParams().id;

  const { data: groupId } = useGetGroupId(proxyUserId);

  return (
    <FillScreen className="flex flex-col gap-7 p-10">
      {groupId.peopleGroupId ? (
        <RuleAndPolicyDetail
          proxyUserId={proxyUserId}
          peopleGroupId={groupId.peopleGroupId}
        />
      ) : (
        <RuleAndPolicyEmpty proxyUserId={proxyUserId} />
      )}
    </FillScreen>
  );
}
